import React, {Component, useEffect} from "react";

import {Box} from "react-bulma-components";
import {Columns} from "react-bulma-components";
import {Form} from "react-bulma-components";
import {Heading} from "react-bulma-components";
import {Button} from "react-bulma-components";
import {Icon} from "react-bulma-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPoundSign} from "@fortawesome/free-solid-svg-icons";
import {getSuggestedRate, getShortTermRate} from "../Utils/RentalRateCalculator";
import {useSelector} from "react-redux";
import {getRentalMarginData} from "../../state/selectors";
import {Picker} from "../Utils/Picker";
import {getDaysBetween} from "../../utils";
import RateCardPicker from "../Settings/RateCards/RateCardPicker";

export const RatesSection = ({rental, onChange, margins, suggestedRate, onRateCardChange, rateCards}) => {
  let days = 0
  let day1_2Rate, day3_6Rate, day7_27Rate, day28_plusRate = 0;
  let day1_2RateIns, day3_6RateIns, day7_27RateIns, day28_plusRateIns = 0;
  let day1_2RateAdm, day3_6RateAdm, day7_27RateAdm, day28_plusRateAdm = 0;

  if (rental.rate_card && rental.rate_card.id) {
    day1_2Rate = rental.rate_card.day1_2_rate * (1-(rental.day1_2_discount / 100)); // apply discount before other items are calculated
    day3_6Rate = rental.rate_card.day3_6_rate * (1-(rental.day_3_6_discount / 100));
    day7_27Rate = rental.rate_card.day7_27_rate * (1-(rental.day_7_27_discount / 100));
    day28_plusRate = rental.rate_card.day_28_plus_rate * (1-(rental.day_28_plus_discount / 100));

    day1_2RateIns = Math.round((day1_2Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day3_6RateIns = Math.round((day3_6Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day7_27RateIns = Math.round((day7_27Rate * rental.rate_card.insurance_perc) * 100) / 100;
    day28_plusRateIns = Math.round((day28_plusRate * rental.rate_card.insurance_perc) * 100) / 100;

    day1_2RateAdm = Math.round((day1_2Rate * rental.rate_card.admin_perc) * 100) / 100;
    day3_6RateAdm = Math.round((day3_6Rate * rental.rate_card.admin_perc) * 100) / 100;
    day7_27RateAdm = Math.round((day7_27Rate * rental.rate_card.admin_perc) * 100) / 100;
    day28_plusRateAdm = Math.round((day28_plusRate * rental.rate_card.admin_perc) * 100) / 100;
  }

  if (rental.start_date && rental.finish_date) {
    days = getDaysBetween(new Date(rental.start_date), new Date(rental.finish_date))
  }
  let totalHireCost = (Math.round( ((rental.short_term_total * 1.2) + rental.short_term_insurance_total + (rental.short_term_admin_total * 1.2)) * 100 )) / 100;



  const rentalMarginObjects = margins.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {});

  const getMileageExceeeded = () => {
    if (!rental.start_mileage || !rental.term || !rental.mileage_allowance || !rental.vehicle || !rental.vehicle.model) {
      return null
    } else {
      const totalMileage = (rental.mileage_allowance / 52 * rental.term) + rental.start_mileage;
      return (totalMileage > rental.vehicle.model.mileage_limit)
    }
  }

  const getTermMileage = () => {
    let termMileage = String(rental.mileage_allowance && rental.term ? rental.mileage_allowance * rental.term / 52 : 0)
    if (getMileageExceeeded()) {
      termMileage = termMileage + " WARNING - MILEAGE TOO HIGH"
    }
    return termMileage
  }
  const handleMarginChange = e => {
    let isBlank = e.target.value === 'BLANK' && e.target.key === -1;
    const toUpdate = {
      target: {
        name: "margin",
        value: isBlank ? {} : rentalMarginObjects[e.target.value]
      }
    }
    onChange(toUpdate)
  }

  const onCheck = (e) => {
      const toUpdate = {
          target: {
              name: e.target.name,
              value: e.target.checked
          }
      }
      onChange(toUpdate)
  }

  const getTotalCost = () => {

  }


  return (
    <Box>
      <Heading>Rates</Heading>
      <Columns>
        <Columns.Column>
          <Form.Field className="has-addons">
            <Form.Control>
              <Form.Label>Type</Form.Label>
              <Button
                color={rental.rental_type === "LT" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "LT"}})}
              >
                Long Term
              </Button>
              <Button
                color={rental.rental_type === "ST" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "ST"}})}
              >
                Short Term
              </Button>
              <Button
                color={rental.rental_type === "FOC" ? "primary" : ""}
                onClick={() => onChange({target: {name: "rental_type", value: "FOC"}})}
              >
                Free of Charge
              </Button>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        {rental.rental_type === "ST" &&
            <Columns.Column>
                <RateCardPicker
                    value={rental.rate_card}
                    editable={true}
                    disabled={false}
                    options={rateCards}
                    onChange={onRateCardChange}
                    inlineEdit={false}
                    blank={true}
                    label={"Rate Card (*)"}
                />
            </Columns.Column>
        }
      </Columns>
      {rental.rental_type === 'LT' &&
        <div>
          <Columns>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Term (Weeks) (*)</Form.Label>
                  <Form.Input
                    type="number"
                    name="term"
                    onChange={onChange}
                    value={rental.term}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Annual Mileage (*)</Form.Label>
                  <Form.Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>

            <Columns.Column>
              <Form.Field>
                <Form.Label>Additional Costs (*)</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="number"
                    name="additional_cost"
                    onChange={onChange}
                    value={String(rental.additional_cost)}
                  />
                  <Icon align={"left"} className={"small-icon"}>
                    <FontAwesomeIcon icon={faPoundSign}/>
                  </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Picker
                name={"margin"}
                label={"Margin (*)"}
                value={rental.margin}
                onChange={handleMarginChange}
                options={margins}
                optionField={"name"}
                blank={true}
              />
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Rate Card Long Term Daily Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={suggestedRate ? "number" : "text"}
                      onChange={onChange}
                      value={suggestedRate ? suggestedRate.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) : "Unable To Calculate Rate"}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Control>
                <Form.Label>Override</Form.Label>
                <Form.Checkbox
                  type="checkbox"
                  name="cost_override"
                  onChange={onCheck}
                  checked={rental.cost_override}
                />
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Long Term Daily Rate (*)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="long_term_daily"
                      onChange={onChange}
                      value={String(rental.long_term_daily)}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Daily Insurance Charge (*)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="daily_insurance_charge"
                      onChange={onChange}
                      value={String(rental.daily_insurance_charge)}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
              <Columns.Column></Columns.Column>
              <Columns.Column></Columns.Column>
              <Columns.Column></Columns.Column>
              <Columns.Column>
                  <Form.Label>Total Insurance Cost</Form.Label>
                  <Form.Input
                    disabled={true}
                    value={(rental.daily_insurance_charge && rental.term) ? (rental.daily_insurance_charge * 7) * rental.term : 0}
                  />
              </Columns.Column>
          </Columns>
          <Heading size={6}>Term Totals</Heading>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Total Mileage</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="text"
                    value={getTermMileage()}
                    color={getMileageExceeeded() ? "danger" : ""}
                    textColor={getMileageExceeeded() ? "danger" : ""}
                    textWeight={getMileageExceeeded() ? "bold" : ""}
                    disabled
                    readOnly
                  />
                </Form.Control>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Label>Total Cost</Form.Label>
                <Form.Control>
                  <Form.Input
                    type="number"
                    value={rental.total}
                    disabled
                    readOnly
                  />
                  <Icon align={"left"} className={"small-icon"}>
                    <FontAwesomeIcon icon={faPoundSign}/>
                  </Icon>
                </Form.Control>
              </Form.Field>
            </Columns.Column>
          </Columns>
        </div>
      }
      {
        rental.rental_type === 'ST' &&
        <div>
          <Columns>
              <Columns.Column>
                <Form.Label>Apply Day 1-2 Rate</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_day1_2_rate}
                    name={"apply_day1_2_rate"}
                    onChange={onCheck}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Apply Day 3-6 Rate</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_day3_6_rate}
                    name={"apply_day3_6_rate"}
                    onChange={onCheck}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Apply Day 7-27 Rate</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_day7_27_rate}
                    name={"apply_day7_27_rate"}
                    onChange={onCheck}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Apply Day 28+ Rate</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_day_28_plus_rate}
                    name={"apply_day_28_plus_rate"}
                    onChange={onCheck}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Apply Insurance</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_insurance}
                    name={"apply_insurance"}
                    onChange={onCheck}
                />
              </Columns.Column>
              <Columns.Column>
                <Form.Label>Apply Admin Fee</Form.Label>
                <Form.Checkbox
                    checked={rental.apply_admin_fee}
                    name={"apply_admin_fee"}
                    onChange={onCheck}
                />
              </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 1-2 rate Discount (%)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"number"}
                      name="day1_2_discount"
                      value={rental.day1_2_discount}
                      onChange={onChange}
                    />
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 3-6 rate Discount (%)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"number"}
                      name="day_3_6_discount"
                      value={rental.day_3_6_discount}
                      onChange={onChange}
                    />
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 7-27 rate Discount (%)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"number"}
                      name="day_7_27_discount"
                      value={rental.day_7_27_discount}
                      onChange={onChange}
                    />
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 28+ rate Discount (%)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"number"}
                      name="day_28_plus_discount"
                      value={rental.day_28_plus_discount}
                      onChange={onChange}
                    />
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 1-2 rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day1_rate"
                      value={day1_2Rate}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 3-6 rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day1_rate"
                      value={day3_6Rate}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 7-27 rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day1_rate"
                      value={day7_27Rate}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 28+ rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day28_rate"
                      value={day28_plusRate}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 1-2 Insurance Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day1_2_rate_insurance"
                      value={day1_2RateIns}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 3-6 Insurance Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day3_6_rate_insurance"
                      value={day3_6RateIns}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 7-27 Insurance Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day7_27_rate_insurance"
                      value={day7_27RateIns}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 28+ Insurance Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day28_plus_rate_insurance"
                      value={day28_plusRateIns}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 1-2 Admin Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day1_2_rate_admin"
                      value={day1_2RateAdm}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 3-6 Admin Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day3_6_rate_admin"
                      value={day3_6RateAdm}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
              <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 7-27 Admin Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day7_27_rate_admin"
                      value={day7_27RateAdm}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Day 28+ Admin Rate</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name="day28_plus_rate_admin"
                      value={day28_plusRateAdm}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
          <Columns>
            <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Daily Mileage (*)</Form.Label>
                  <Form.Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Hire Total</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type={"text"}
                      name={"short_term_total"}
                      onChange={onChange}
                      value={rental.short_term_total.toLocaleString(undefined, {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2
                      }) || "Unable To Calculate Rate"}
                      disabled={!rental.cost_override}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Insurance Charge</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="short_term_insurance_total"
                      onChange={onChange}
                      value={String(rental.short_term_insurance_total)}
                      disabled={!rental.cost_override}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Admin Charge</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="short_term_admin_total"
                      onChange={onChange}
                      value={String(rental.short_term_admin_total)}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
            <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Total Hire Cost (Inc VAT)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="short_term_total_hire"
                      value={totalHireCost}
                      disabled={true}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
            </Columns.Column>
          </Columns>
        </div>
      }
      {rental.rental_type === "FOC" &&
        <Columns>
          <Columns.Column>
              <Form.Field>
                <Form.Field>
                  <Form.Label>Daily Insurance Charge (*)</Form.Label>
                  <Form.Control>
                    <Form.Input
                      type="number"
                      name="daily_insurance_charge"
                      onChange={onChange}
                      value={String(rental.daily_insurance_charge)}
                    />
                    <Icon align={"left"} className={"small-icon"}>
                      <FontAwesomeIcon icon={faPoundSign}/>
                    </Icon>
                  </Form.Control>
                </Form.Field>
              </Form.Field>
          </Columns.Column>
          <Columns.Column>
              <Form.Control>
                <Form.Field>
                  <Form.Label>Daily Mileage (*)</Form.Label>
                  <Form.Input
                    type="number"
                    name="mileage_allowance"
                    onChange={onChange}
                    value={rental.mileage_allowance}
                    required
                  />
                </Form.Field>
              </Form.Control>
            </Columns.Column>
        </Columns>
      }
      <Columns>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Excess Mileage Cost (£ per mile) (*)</Form.Label>
            <Form.Control>
              <Form.Input
                name="excess_mileage_charge_per_mile"
                type="number"
                value={String(
                  rental.excess_mileage_charge_per_mile
                )}
                onChange={onChange}
              />
              <Icon align={"left"} className={"small-icon"}>
                <FontAwesomeIcon icon={faPoundSign}/>
              </Icon>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
        <Columns.Column>
          <Form.Field>
            <Form.Label>Early Return Penalty</Form.Label>
            <Form.Control>
              <Form.Input
                name={"early_return_penalty"}
                value={rental.early_return_penalty}
                onChange={onChange}
                type={"number"}
              />
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      {rental.rental_type === "LT" &&
      <Columns>
        <Columns.Column>
          <Form.Field className="has-addons">
            <Form.Control>
              <Form.Label>Invoice Interval</Form.Label>
              <Button
                color={rental.invoice_interval === "ONE_OFF" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "ONE_OFF"}})}
              >
                One Off
              </Button>
              <Button
                color={rental.invoice_interval === "WEEKLY" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "WEEKLY"}})}
              >
                Weekly
              </Button>
              <Button
                color={rental.invoice_interval === "MONTHLY" ? "primary" : ""}
                onClick={() => onChange({target: {name: "invoice_interval", value: "MONTHLY"}})}
              >
                Monthly
              </Button>
            </Form.Control>
          </Form.Field>
        </Columns.Column>
      </Columns>
      }
    </Box>
  );
}

export default RatesSection;
